'use strict';

import React from 'react'

import Loader from '@Pure/Loader'
import Image  from '@Pure/Image'

import _ from 'lodash'

export default class FileInputV2 extends React.Component
{
	constructor (props)
	{
		super(props);

		this.state =
		{
			id: ++app.form_index,
			files: []
		};

		this.removeFile = this.removeFile.bind(this);
	}

	componentWillMount ()
	{
		const component = this, props = this.props;

		component.setState(
		{
			loading: false,
			files: []
		});
	}

	componentDidMount ()
	{
		const component = this, props = this.props;

		component.setState(
		{
			label: props.label
		});

		let data =
		{
			value: props.defaultValue || props.value,
			name: props.name
		};

		props.onChange(null, data);
	}

	removeFile (e, preview_to_remove)
	{
		const component = this, props = this.props;

		let data = (props.data || { })[props.name] || { }, previews;

		e.preventDefault();

		app.emit('documentClick');

		if (data instanceof Array)
		{
			previews = _.cloneDeep(data);
		}
		else if (data && data.previews instanceof Array)
		{
			previews = _.cloneDeep(data.previews);
		}
		else
		{
			previews = [];
		}

		previews = previews.filter(function (preview)
		{
			return preview.filename !== preview_to_remove.filename;
		});

		props.onChange(null,
		{
			value: previews,
			name: props.name
		});
	}

	render ()
	{
		const component = this, props = this.props, state = this.state;

		let label, element, type, info, warning, error;
		let previews = [], loader, upload_msg, delete_msg;

		let class_name = props.className || 'c-form-element';

		let status = props.status[props.name] || { };

		let data = ((props.data || { })['__attachments'] || [])
		.filter(function (preview)
		{
			return preview.form_name === props.name;
		});

		if (data instanceof Array)
		{
			previews = _.cloneDeep(data);
		}

		if (component.state.loading === true)
		{
			loader =
			(
				<div className="c-form-element__file-loader">
					<Loader className="c-loader" bemit={ ['small', 'primary', 'bg-white'] } />
				</div>
			);
		}

		let front_indicator =
		(
			<svg className="o-svg-icon o-svg-icon--eye c-form-label__icon">
				<use xlinkHref="/images/icons.svg#svg-icon-eye"></use>
			</svg>
		);

		if (props.front_indicator !== true)
		{
			front_indicator = undefined;
		}

		if (props.label)
		{
			label =
			(
				<label className="c-form-label c-form-label--file"
					htmlFor={ (props.id_prefix || '') + component.state.id }>
					{ front_indicator }
					{ props.label }
				</label>
			);
		}

		if (status.info)
		{
			info =
			(
				<div className="c-form-label c-form-label--info">
					{ status.info }
				</div>
			);

			class_name += ' c-form-element--info';
		}

		if (status.warning)
		{
			warning =
			(
				<div className="c-form-label c-form-label--file c-form-label--warning">
					{ status.warning }
				</div>
			);

			class_name += ' c-form-element--warning';
		}

		if (status.error)
		{
			error =
			(
				<div className="c-form-label c-form-label--file c-form-label--error">
					{ status.error }
				</div>
			);

			class_name += ' c-form-element--error';
		}

		if (status.data && status.data.uploaded_files)
		{
			upload_msg =
			(
				<div className="c-form-label c-form-label--info">
					{ status.data.uploaded_files.length }
					{
						status.data.uploaded_files.length > 1 ?
						' fichiers envoyés.' : ' fichier envoyé.'
					}
				</div>
			);
		}

		if (status.data && status.data.uploaded_files)
		{
			delete_msg =
			(
				<div className="c-form-label c-form-label--info">
					{ status.data.deleted_files.length }
					{
						status.data.deleted_files.length > 1 ?
						' fichiers supprimés.' : ' fichier supprimé.'
					}
				</div>
			);
		}

		previews = previews.map(function (preview, index)
		{
			let extension = preview.filename.slice(preview.filename.lastIndexOf('.'),
				preview.filename.length);

			let filename  = preview.filename.slice(0,
				preview.filename.indexOf(extension));

		// shorten filename if too long and add '...'
			if (filename.length > 20)
			{
				filename = filename.slice(0, 17) + '...';
			}

			filename += extension;

			let image;

			if (preview.image)
			{
				image =
				(
					<Image className="c-file-thumbnail__preview" src={ preview.image } />
				);
			}
			else if (preview.pdf)
			{
				image =
				(
					<svg className="o-svg-icon o-svg-icon--PDF c-file-thumbnail__icon">
						<use xlinkHref="/images/icons.svg#svg-icon-PDF"></use>
					</svg>
				);
			}
			else if (preview.url)
			{
				image =
				(
					<Image className="c-file-thumbnail__preview" src={ preview.url } />
				);
			}

			let output =
			(
				<div className="c-file-thumbnail" key={ index }>

					{ image }

					<div className="c-file-thumbnail__title"
						htmlFor={ (props.id_prefix || '') + component.state.id }>
						{ filename }
					</div>

					<button type="button" className="c-file-thumbnail__delete"
						title="effacer"
						onClick={ function (e) { component.removeFile(e, preview); } }>
						<div className="c-file-thumbnail__delete-icon"></div>
					</button>

				</div>
			);

			return output;
		});

		element =
		(
			<input type="file" className="c-form-element__file" name={ props.name }
				onChange={ handleChange } multiple={ props.multiple }
				id={ (props.id_prefix || '') + component.state.id }
				accept={ props.accept }
				readOnly={ props.readOnly || false }
			/>
		);

		let trigger =
		(
			<label className="c-btn c-btn--primary file file"
				htmlFor={ (props.id_prefix || '') + component.state.id }>
				{ props.button_txt || 'Ajouter' }
			</label>
		);

		let output =
		(
			<div className={ class_name }>

				{ label }

				{ info }

				{ upload_msg }

				{ delete_msg }

				{ warning }

				{ error }

				<div className="u-flex u-items-center u-flex-wrap">

					{ element }

					{ props.children }

					{ previews }

					{ trigger }

					{ loader }

				</div>

			</div>
		);

		return props.type === 'hidden' ? element : output;

		function handleChange (e)
		{
			let new_files = e.target.files, previews = [];

			e.preventDefault();

			if (new_files.length === 0) return;

			let data = ((props.data || { })['__attachments'] || [])
			.filter(function (preview)
			{
				return preview.form_name === props.name;
			});

			if (data instanceof Array)
			{
				previews = _.cloneDeep(data);
			}

			if (data instanceof Array)
			{
				previews = _.cloneDeep(data);
			}
			else if (data.previews instanceof Array)
			{
				previews = _.cloneDeep(data.previews);
			}

			component.setState(
			{
				loading: true
			});

			let nb_files = new_files.length;

			if (props.multiple !== 'multiple')
			{
				nb_files = 1;
			}

			for (let i = 0; i < nb_files; i++)
			{
				fileListener(new_files[i]);
			}

			function fileListener (file)
			{
				let reader = new FileReader();

				reader.onloadend = function ()
				{
					let types =
					[
						'image/jpeg',
						'image/png',
						'image/svg+xml',
						'image/gif'
					];

					let preview =
					{
						filename: file.name,
						file: file,
						form_name: props.name
					};

					if (types.indexOf(file.type) !== -1)
					{
						preview.image = reader.result;
						preview.type  = file.type;
					}
					else if (file.type === 'application/pdf')
					{
						preview.pdf  = reader.result;
						preview.type = 'application/pdf';
					}

					previews.push(preview);

					if (--nb_files === 0)
					{
						e.target.value = '';

						props.onChange(e,
						{
							value: previews,
							name: props.name
						});

						component.setState(
						{
							loading: false
						});
					}
				};

				reader.readAsDataURL(file);
			}
		}
	}
}